import { apiCall } from './_helper';
import { getDateFilter } from '../utils/date';

//------------Main Dashboard Page-------------------
// Gets a list of companies. Used in the dashboard and settings page
// Tested and working: 4/6/2025
export const getCompanyList = async () => {
  return await apiCall({
    url: 'dashboard/getCompanyList',
    reportingUrl: true,
    notJSON: true,
  });
};

// Gets a list of statuses by count
// Tested and working: 4/6/2025
export const dashboardStatusCount = async () => {
  return await apiCall({
    url: `dashboard/statusCounts/?companyId=` + sessionStorage.getItem('companyid'),
    reportingUrl: true,
  });
};

// Search for shipments based on various filters
// Tested and working: 4/6/2025
export const getShipmentStatus = async (shipmentData) => {
  const filter = {
    filter: {
      filter_reference: shipmentData?.reference || null,
      filter_consignmentRef: shipmentData?.consignmentRef || null,
      departureStartDate: shipmentData?.departureStartDate ? getDateFilter(shipmentData?.departureStartDate) : null,
      departureEndDate: shipmentData?.departureEndDate ? getDateFilter(shipmentData?.departureEndDate, true) : null,
      arrivalStartDate: shipmentData?.arrivalStartDate ? getDateFilter(shipmentData?.arrivalStartDate) : null,
      arrivalEndDate: shipmentData?.arrivalEndDate ? getDateFilter(shipmentData?.arrivalEndDate, true) : null,
      vehicleIdentity: shipmentData?.vehicleIdentity || null,
      lrnMRN: shipmentData?.lrnMRN || null,
      status: shipmentData?.status === 1 ? null : shipmentData?.status || null,
      searchCompanyId: shipmentData?.companyId === 'null' ? null : shipmentData?.companyId || null,
    },
    amount: shipmentData?.amount || 50,
    skip: shipmentData?.skip || 0,
    companyId: parseInt(sessionStorage.getItem('companyid')),
  };

  return await apiCall({
    url: 'dashboard/getShipmentsStatus',
    method: 'POST',
    body: JSON.stringify(filter),
    errorMessage: 'There was an error fetching the shipment status',
    reportingUrl: true,
  });
};

//------------Shipment Details Page-------------------

// Gets the shipment status for a specific shipment view
// Tested and working: 4/6/2025
export const getShipmentStatusForShipmentView = async (headerId, companyId) => {
  return await apiCall({
    url:
      'dashboard/getShipmentDetails?headerId=' +
      headerId +
      '&companyId=' +
      (companyId || sessionStorage.getItem('companyid')),
    reportingUrl: true,
  });
};
// Gets the details of a consignment based on the consignmentId
// Tested and working: 4/6/2025
export const getConsigmentDetails = async (consignmentId, companyId) => {
  return await apiCall({
    url:
      'dashboard/getConsignment?headerId=' +
      consignmentId +
      '&companyId=' +
      (companyId || sessionStorage.getItem('companyid')),
    reportingUrl: true,
  });
};

// Gets a list of errors for a header or consignment
export const getErrorsDetails = async (headerId, consignmentId) => {
  let endpoint = '';
  if (consignmentId) {
    endpoint = `ens/errors?consignmentId=${consignmentId}`;
  } else {
    endpoint = `ens/errors?headerId=${headerId}`;
  }

  return await apiCall({
    url: endpoint,
    notJSON: true,
    //reportingUrl: true,
  });
};
